import {
  defaultListQuery,
  isListPageSize,
  type ListQueryParams,
} from "@/shared/list/listQueryTypes";
import { DEFAULT_LIST_PAGE_SIZE, type ListPageSize } from "@/shared/list/pagination";

/** Read list chrome state from URL search params. */
export function parseListSearchParams(
  searchParams: URLSearchParams,
  filterKeys: readonly string[] = [],
  defaultPageSize: ListPageSize = DEFAULT_LIST_PAGE_SIZE,
): ListQueryParams {
  const pageRaw = Number(searchParams.get("page") ?? "1");
  const pageSizeRaw = Number(searchParams.get("pageSize") ?? String(defaultPageSize));
  const page = Number.isFinite(pageRaw) && pageRaw >= 1 ? Math.floor(pageRaw) : 1;
  const pageSize: ListPageSize = isListPageSize(pageSizeRaw) ? pageSizeRaw : defaultPageSize;
  const q = searchParams.get("q") ?? "";
  const status = searchParams.get("status") ?? "all";
  const filters: Record<string, string> = {};
  for (const key of filterKeys) {
    const v = searchParams.get(key);
    if (v) filters[key] = v;
  }
  return defaultListQuery({ page, pageSize, q, status, filters });
}

/** Write list chrome state into URLSearchParams (omit defaults). */
export function writeListSearchParams(
  params: ListQueryParams,
  filterKeys: readonly string[] = [],
  defaultPageSize: ListPageSize = DEFAULT_LIST_PAGE_SIZE,
): URLSearchParams {
  const sp = new URLSearchParams();
  if (params.page !== 1) sp.set("page", String(params.page));
  if (params.pageSize !== defaultPageSize) sp.set("pageSize", String(params.pageSize));
  if (params.q.trim()) sp.set("q", params.q.trim());
  if (params.status && params.status !== "all") sp.set("status", params.status);
  for (const key of filterKeys) {
    const v = params.filters[key];
    if (v && v !== "all") sp.set(key, v);
  }
  return sp;
}
